import { render, staticRenderFns } from "./catlogDrawer.vue?vue&type=template&id=f906d986&"
import script from "./catlogDrawer.vue?vue&type=script&lang=js&"
export * from "./catlogDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports